import React from 'react';
import ReactGA from 'react-ga4';
import MediaQuery from 'react-responsive'
import './Home10.scss'
import Footer from '../../../Footer/Footer';

const Home10 = ({sectionCurrently, positionCurrently, setSectionCurrently, setPositionCurrently, Section, Position, responsive}) => {

    const scroll = () =>{
        return sectionCurrently === Section.Section9 &&
                (positionCurrently === Position.TOP ||
                positionCurrently === Position.BOTTOM) &&
                !responsive
    }

    const handleRedirect = () => {
        const url = 'https://app.conkarta.com/application';
        window.open(url, '_blank');

        try {
            ReactGA.event({
                category: 'Botón',
                action: 'Clic en botón',
                label: 'Botón Sección "Más preguntas?',
            });
        } catch (error) {
            console.error('Error al enviar el evento a GA:', error);
        }
    };

    const mx = "ten-body-section fade-in-animation-10 disposition-column justify-center align-center ";
    const mm = "ten-body-section-m fade-in-animation-10 disposition-column justify-center align-center ";

    const titleTiny = "Drop the limits";
    const titleBig = "Experience U.S. Power";

    return (
        <>
            <MediaQuery minWidth={900}>
                <div className = { `${mx} ${scroll() ? "fade-out-animation" : ""}`}>
                    <div className="speak-section">
                        <img src = "assets/Home/Home10/gradient-background.png" className = "gradient-img" alt = "Background"></img>
                        <div className="speak-elements-section disposition-column justify-center align-center">
                            <p className = "text-1">{titleTiny}</p>
                            <p className = "text-2">{titleBig}</p>
                            <button className = "reserve-button" onClick = {() => handleRedirect()}>Apply now</button>
                        </div>
                        <img src = "assets/Home/Home10/karta-app-founder2.png" className = "group-app-img" alt = "App"></img>
                    </div>
                    <Footer
                        sectionCurrently = {sectionCurrently} 
                        positionCurrently = {positionCurrently} 
                        setSectionCurrently = {setSectionCurrently}
                        setPositionCurrently = {setPositionCurrently}
                        Section = {Section}
                        Position = {Position}
                        responsive = {false}
                    ></Footer>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={900}>
                <div className = { `${mm} ${scroll() ? "fade-out-animation" : ""}`}>
                    <div className="speak-section">
                        <img src = "assets/Home/Home10/gradient-background.png" className = "gradient-img" alt = "Background"></img>
                        <div className="speak-elements-section disposition-column justify-center align-start">
                            <p className = "text-1">{titleTiny}</p>
                            <p className = "text-2">{titleBig}</p>
                            <button className = "reserve-button" onClick = {() => handleRedirect()}>Apply now</button>
                        </div>
                        <img src = "assets/Home/Home10/app-movil2.png" className = "group-app-img" alt = "App"></img>
                    </div>
                </div>
            </MediaQuery>
        </>
    );
};

export default Home10;
